import { Button } from 'components/ui/button';
import { useMemo } from 'react';
import { FeatureFlag } from 'types/features';
import { useHasPermissions } from 'utils/permissionUtil';
import { useFeatureFlags } from 'utils/useFeatureFlags';
import { AppButtonProps, buttonStyle } from './buttonStyle';
import ButtonIconSlot from './ButtonIconSlot';

type Props = AppButtonProps & {
    permissions?: string[];
    hasAuthority?: boolean;
    requiredFeature?: FeatureFlag;
};

export default function PermissionButton({
    permissions,
    hasAuthority = false,
    requiredFeature,
    variant,
    color,
    size,
    className,
    startIcon,
    endIcon,
    children,
    ...buttonProps
}: Props) {
    const { isFlowDisabled } = useFeatureFlags(requiredFeature);
    const hasPermissions = useHasPermissions(permissions ?? []);

    const shouldShowButton = useMemo(() => {
        const hasPermission = permissions ? hasPermissions : false;
        return (hasPermission || hasAuthority) && !isFlowDisabled;
    }, [hasAuthority, hasPermissions, isFlowDisabled, permissions]);

    if (!shouldShowButton) return null;
    return (
        <Button {...buttonProps} {...buttonStyle({ variant, color, size }, className)}>
            {startIcon ? (
                <ButtonIconSlot side="start" size={size}>
                    {startIcon}
                </ButtonIconSlot>
            ) : null}
            {children}
            {endIcon ? (
                <ButtonIconSlot side="end" size={size}>
                    {endIcon}
                </ButtonIconSlot>
            ) : null}
        </Button>
    );
}
